import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex, Icon } from 'Components/UI'

import arrowCarouselGlyph from 'Assets/_Legacy/Svg/arrowCarousel.svg'

export const Container = styled(Flex).attrs({
  display: ['none', 'none', 'flex'],
})`
  position: absolute;
  z-index: 12;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  height: 10px;
`

const navButtonSecondaryCss = ({ secondary }) =>
  secondary &&
  css`
    fill: ${themeGet('colors.pinkAmaranthDark')};

    &:hover {
      fill: ${themeGet('colors.pinkAmaranth')};
    }
  `

const shouldForwardProp = prop => {
  return !['secondary'].includes(String(prop))
}

const NavButton = styled(Flex)
  .attrs({
    as: 'button',
  })
  .withConfig({
    shouldForwardProp,
  })`
  padding: 0;
  justify-content: center;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  position: absolute;
  fill: ${themeGet('colors.primary')};

  &:hover {
    fill: ${themeGet('colors.calculator.action')};
  }

  ${navButtonSecondaryCss}
`

export const NavButtonPrev = styled(NavButton).withConfig({
  shouldForwardProp,
})`
  left: 0;
  transform: translateX(-100%) translateY(-50%);
`

export const NavButtonNext = styled(NavButton).withConfig({
  shouldForwardProp,
})`
  right: 0;
  transform: translateX(100%) translateY(-50%);
`

const rotateCss = ({ angle }) =>
  angle &&
  css`
    transform: rotateZ(${angle}deg);
  `

export const ArrowIcon = styled(Icon).attrs({
  glyph: arrowCarouselGlyph,
  size: [24, 24, 24, 40],
})`
  ${rotateCss};
`
